import AppShell from '@/components/app-shell';
import NotFound from '@/routes/not-found/not-found';

function FullNotFound() {
  return (
    <AppShell>
      <div data-testid="app" className="mx-auto flex h-full max-w-7xl flex-col justify-center bg-greige px-4 pb-6">
        <div>
          <NotFound />
        </div>
      </div>
    </AppShell>
  );
}

export default FullNotFound;
